// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col } from '../../components/Elemental'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Components/Containers
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import LogoFull from '../../components/LogoFull'
import Select from '../../components/Select'
import Warning from '../Warning'

// Normalize
import * as normalize from '../../constants/normalize'

// Options
import * as options from '../../constants/options'

// Validate
import * as validate from '../../constants/validate'

// Actions
import { changeCities, fetchCities } from '../App/actions'
import { signUp } from './actions'
import { change } from 'redux-form'
import withParams from '../../hoc/WithParams'
class SignUpPage extends Component {
  handleFormSubmit = (reduxFormData) => {
    const { signUp, history } = this.props

    return signUp(reduxFormData, history)
  }

  render() {
    const { localLoading, cities, fetchCities, change, handleSubmit } = this.props

    const selectedUf = value => options.uf.some(uf => uf.value === value) ? undefined : 'Opção Inexistente'
    const selectedCity = value => cities.some(city => city.value === value) ? undefined : 'Opção Inexistente'

    return (
      <div className="sign-up-page">
        <LogoFull width={220} gutterBottom={10} />
        <Form autoComplete={'off'} onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Row gutter={10}>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="name"
                label="Nome"
                gutter={15}
                validate={validate.required} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="surname"
                label="Sobrenome"
                gutter={15}
                validate={validate.required} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="phone"
                type="phone"
                label="Celular"
                placeholder="(00)00000-0001"
                gutter={15}
                normalize={normalize.phone}
                validate={[validate.required, validate.minLength13]} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="oabNumber"
                label="Número OAB"
                gutter={15}
                handleBlur={(value) => value.length <= 6 ? change('oabNumber', '0'.repeat(6 - value.length) + value) : null}
                normalize={normalize.oabNumber}
                validate={[validate.required]} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Select}
                name="oabUf"
                label="UF OAB"
                gutter={15}
                handleSelect={option => fetchCities(option.value)}
                handleClear={() => changeCities([])}
                normalize={normalize.uf}
                options={options.uf}
                validate={[validate.required, selectedUf]} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Select}
                name="city"
                label="Cidade"
                gutter={15}
                disabled={cities.length === 0 ? true : false}
                options={cities}
                validate={[validate.required, selectedCity]} />
            </Col>
            <Col gutter={10} sm="100%">
              <Field
                component={Input}
                name="email"
                type="email"
                label="Email"
                gutter={15}
                validate={[validate.required, validate.email]} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="password"
                type="password"
                label="Senha"
                gutter={15}
                validate={[validate.required, validate.validatePassword]} />
            </Col>
            <Col gutter={10} sm="50%">
              <Field
                component={Input}
                name="passwordConfirm"
                type="password"
                label="Confirmar Senha"
                gutter={15}
                validate={[validate.required, validate.validatePassword]} />
            </Col>
          </Row>
          <p className="sign-up-page__terms-of-use">
            Ao se cadastrar você concorda com nossos{' '}
            <a target="_blank" href="https://comacordo.com.br/termos-de-uso" className="sign-up-page__terms-of-use--link">
              termos de uso
            </a>
            .
          </p>
          <Warning gutter={40} align="center" />
          <Button type="submit" localLoading={localLoading} gutter={15}>Cadastrar</Button>
        </Form>
        <h3 className="sign-up-page__redirect">
          <NavLink className="sign-up-page__link" to="/login" >Voltar para o login</NavLink>
        </h3>
      </div>
    )
  }
}

const reduxFormValidate = (values) => {
  const errors = {}
  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Senhas não coincidem.'
  }

  if (values.oabNumber) {
    errors.oabUf = ''
  }

  return errors
}

SignUpPage = reduxForm({
  form: 'signUp',
  validate: reduxFormValidate
})(SignUpPage)

SignUpPage = connect((state, ownProps) => {
  return {
    localLoading: state.app.localLoading,
    err: state.app.err,
    success: state.app.success,
    cities: state.app.cities,
    history: ownProps.history
  }
}, { changeCities, fetchCities, signUp, change })(SignUpPage)

export default withParams(SignUpPage)
